var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var solidBorder = function (color) { return ({
    border: "1px solid " + color,
}); };
export default {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        var iconOnly = props.iconOnly, fluid = props.fluid, pointing = props.pointing, pills = props.pills, primary = props.primary, underlined = props.underlined, vertical = props.vertical;
        return __assign({ display: 'flex' }, (iconOnly && { alignItems: 'center' }), (vertical && __assign({ flexDirection: 'column' }, (!fluid && { width: pxToRem(200) }), (iconOnly && {
            display: 'inline-block',
            width: 'auto',
        }))), (!pills &&
            !iconOnly &&
            !(pointing && vertical) &&
            !underlined && __assign({}, solidBorder(variables.borderColor), (primary && __assign({}, solidBorder(variables.primaryBorderColor))), { borderRadius: pxToRem(4) })), (underlined && {
            borderBottom: "2px solid " + variables.primaryUnderlinedBorderColor,
        }), { minHeight: pxToRem(24), margin: 0, padding: 0, listStyleType: 'none' });
    },
};
